export const globals= {
    THUNDERCALL_SIGNUP_PROXY_URL: process.env.REACT_APP_THUNDERCALL_SIGNUP_PROXY_URL || "/api/signup",
    TURNSTILE_SITE_KEY: process.env.REACT_APP_TURNSTILE_SITE_KEY || "",
    usStates: ["AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN",
              "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", 
              "NJ", "NM", "NY", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
               "VA", "WA", "WV", "WI", "WY"],
    WebsiteBanner: process.env.REACT_APP_HEADER
};
